
import TankDetails from "../components/app/Tank/TankDetails";

function TankDetailsPage() {
  return (
    <TankDetails></TankDetails>
);
}

export default TankDetailsPage;